module.exports = __webpack_public_path__ + "img/Whymano.eab23846.png";